import { createContext } from 'preact'
import { useContext } from 'preact/hooks'
import type { EventDetails } from '../api/generated/EventDetails'
import { sectionOf, sectionsOf } from './sections'

type CurrentEvent = {
  event: EventDetails
  setEvent: (event: EventDetails) => void
  reload: () => void
}

export const EventContext = createContext<CurrentEvent | null>(null)

/** The event of the pages under `/events/{slug}`, loaded once by `EventSpace`. */
export function useEvent(): CurrentEvent {
  const current = useContext(EventContext)
  if (!current) throw new Error('useEvent outside EventSpace')
  return current
}

/** Where a page under a section goes back to: that section of the user's space, its home without it. */
export function backLink(event: EventDetails, section: string): { href: string; label: string } {
  const { path, label } = sectionOf(sectionsOf(event.role), section)
  return { href: `/events/${event.slug}${path === '/' ? '' : path}`, label }
}
